// src/api/selectionApi.js
import {$authHost, $host} from "./index"; // Импортируем экземпляры axios из главного index.js

export const sendSelectionMail = async (payload) => {
    try {
        const { data } = await $host.post('/api/selection', payload);
        return data;
    } catch (e) {
        throw e;
    }
};

export const createSelection = async (formData) => {
    try {
        // Используем $authHost, так как создавать подборки может только авторизованный админ
        const {data} = await $authHost.post('api/selection/create', formData)
        return data
    } catch (e) {
        // Прокидываем ошибку дальше, чтобы компонент мог её обработать (например, показать alert)
        alert(e.response?.data?.message);
    }
}

// Получение подборки (для страницы гостя)
export const fetchOneSelection = async (id) => {
    try {
        // Используем $host, так как гость заходит без логина
        const {data} = await $host.get('api/selection/' + id)
        return data
    } catch (e) {
        alert(e.response?.data?.message);
    }
}